import RevokeInvitationStore from '../stores/revoke-invitation-store';
import { PendingInvitationMember } from '../types/members-types';

export const closeRevokeInvitationModal = (): void => {
  setModalVisibility(false);
};

export const openRevokeInvitationModal = (): void => {
  setModalVisibility(true);
};

const setModalVisibility = (payload: boolean): void => {
  RevokeInvitationStore.isModalVisible = payload;
};

export const setSelectedPendingInvitation = (
  member: PendingInvitationMember,
): void => {
  RevokeInvitationStore.selectedPendingInviteMember = member;
};
